import Phaser from 'phaser';
import AScene from "./AScene.js";
import AParticle from "./AParticle.js";

export default class AEmitter extends Phaser.GameObjects.Particles.ParticleEmitter
{
    /**
     * @param {AScene} scene 
     */
    constructor(scene, properties, frame = null, atlas = null)
    {
        let manager = new Phaser.GameObjects.Particles.ParticleEmitterManager(scene, atlas == null ? scene.defaultAtlas : atlas, frame);
        properties.particleClass = AParticle;
        super(manager, properties);
        
        manager.emitters.add(this);

        this.anim = properties.anim;
        this.scaleX.onUpdate = this.scaleX.defaultUpdate;
        this.originalUpdate = this.preUpdate;
        this.preUpdate = (time, deltaTime)=>{ this.originalUpdate(time, deltaTime); this.update(time, deltaTime); };
    }

    fadeInOut(maxVal = 1, easeFunc = Phaser.Math.Easing.Linear)
    {
        this.setAlpha((p, k, t)=>{
            let val = (1 - Math.abs(t - .5) * 2) * maxVal;
            return easeFunc(val);
        });
        return this;
    }

    scaleInOut(maxVal = 1, easeFunc = Phaser.Math.Easing.Linear)
    {
        this.setScale((p, k, t)=>{
            let val = (1 - Math.abs(t - .5) * 2) * maxVal;
            return easeFunc(val);
        });
        return this;
    }

    scaleOut(start = 0, end = 1, easeFunc = Phaser.Math.Easing.Linear)
    {
        this.setScale((p, k, t)=>{
            let val = start + (end - start) * t;
            return easeFunc(val);
        });
        return this;
    }

    setTint(from, to, easeFunc = Phaser.Math.Easing.Linear)
    {
        this.tintFunc = ()=>{
            
            this.forEachAlive((p, e)=>{
                let fromCol = Phaser.Display.Color.IntegerToColor(from);
                let toCol = Phaser.Display.Color.IntegerToColor(to);
                p.tint = Phaser.Display.Color.ObjectToColor(Phaser.Display.Color.Interpolate.ColorWithColor(toCol, fromCol, 1, easeFunc(p.lifeCurrent / p.life))).color;
            });
        };
        return this;
    }

    update(time, deltaTime)
    {
        if(this.tintFunc) this.tintFunc();
    }
}